// @ts-nocheck
const requestCache = {};
export const fetch = conf => {
    if (conf.cache) {
        if (requestCache[conf.url]) {
            conf.success(requestCache[conf.url]);
            return;
        }
    }

    if (conf.jsonp) {
        const funcName = `cb${
            Math.random()
                .toString()
                .split(".")[1]
        }`;
        window[funcName] = data => {
            if (conf.cache) {
                requestCache[conf.url] = data;
            }
            window[funcName] = null;
            delete window[funcName];
            conf.success(data);
        };
        const s = document.createElement("script");
        s.async = true;
        s.defer = true;
        s.src = conf.url.replace(/%JSONPFUNC%/, funcName);
        s.onload = () => {
            document.body.removeChild(s);
        };
        document.body.appendChild(s);
        return;
    }

    const e = encodeURIComponent;
    const getParams =
        conf.method === "GET" && conf.data
            ? `?${Object.keys(conf.data)
                  .map(k => `${e(k)}=${e(conf.data[k])}`)
                  .join("&")}`
            : "";

    const xhr = new window.XMLHttpRequest();
    conf.method = conf.method || "GET";
    xhr.onload = evt => {
        const data = evt?.target?.responseText;
        if (conf.success) {
            if (conf.cache) {
                requestCache[conf.url + getParams] = data;
            }
            conf.success(data);
        }
    };
    xhr.onerror = evt => {
        if (conf.error && evt && evt.target && evt.target.responseText) {
            conf.error(evt.target.responseText);
        }
    };
    xhr.open(conf.method, conf.url + getParams);
    if (conf.data && conf.method === "POST") {
        if (typeof conf.data === "object") {
            const formData = new FormData();
            Object.entries(conf.data).forEach(([key, value]) => formData.append(key, value));
            conf.data = formData;
        } else {
            xhr.setRequestHeader("content-type", "application/x-www-form-urlencoded");
        }
    }
    xhr.send(conf.data);
};
